import { getRuntimeConfig } from '@hclinear/hc-linear-react';
import axios, { AxiosInstance } from 'axios';

let authClient: AxiosInstance | null = null;

export function createAxiosAuthClient(): AxiosInstance {
  if (authClient) return authClient;

  authClient = axios.create({
    baseURL: getRuntimeConfig().AUTH_BACKEND_URL,
    withCredentials: true,
  });

  return authClient;
}

const errorMessage = 'Auth client not configured. Call createAxiosAuthClient() first.';

export function getAxiosAuthClient(): AxiosInstance {
  if (!authClient) {
    throw new Error(errorMessage);
  }
  return authClient;
}
